module.exports = __webpack_public_path__ + "img/dashboard_publish_cookbook_title_en.69e9d819.png";